import BaseService from './BaseService';
import {saveAs} from 'file-saver';
import Constants from './../utils/constants';
import moment from 'moment';

export default class BaseServiceCrud extends BaseService {
    // Initializing important variables
    constructor(domain) {
        super(domain);
        this.getList = this.getList.bind(this);
        this.get = this.get.bind(this);
        this.add = this.add.bind(this);
        this.update = this.update.bind(this);
    }

    add(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/`, {
            method: 'POST',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    update(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/${element.id}`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    get(id) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/${id}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getList(criteria) {
        const queryString = this.getCriteria(criteria);
        return this.fetch(`${this.domain}/${this.path}/list${queryString}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getItems() {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/items`, {
            method: 'GET',
        })
            .then((res) => {
                return Promise.resolve(res);
            })
            .catch((err) => {
                throw err;
            });
    }

    remove(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/${element.id}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getCriteriaForDownloading(format, criteria, id) {
        return this.objToQueryString({
            format: format?.enumValue,
            id: id,
            from_time: criteria.fromTime ? moment(criteria.fromTime).format(Constants.DATE_TIME_FORMAT) : undefined,
            to_time: criteria.toTime ? moment(criteria.toTime).format(Constants.DATE_TIME_FORMAT) : undefined
        });
    }

    startDownloading(format, criteria, id) {
        // Get a token from api server using the fetch api
        const query = this.getCriteriaForDownloading(format, criteria, id);
        return this.fetch(`${this.domain}/${this.path}/export${query}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getReportResult(uuid) {
        return this.fetch(`${this.domain}/${this.path}/result/${uuid}`, {
            method: 'GET'
        }).then(res => {
            return Promise.resolve(res);
        });
    }

    export(token, fileLabel, handleError, format, uuid) {
        const url = new URL(`${this.domain}/${this.path}/download/${uuid}/${format}`);
        const headers = {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Pragma: 'no-cahce',
        };
        headers['Authorization'] = token;

        this.fetchGet(url, headers)
            .then(response => {
                console.log('content-disposition', response.headers.get('content-disposition'));
                return response.blob();
            })
            .then(blob => {
                saveAs(blob, fileLabel);
            })
            .catch(err => {
                console.log('downloadFile error', err);
                if (handleError) {
                    handleError('Nie można pobrać pliku!')
                }
            });

    }

    fetchGet(url, headers) {
        // const method = options !== undefined ? options.method : undefined;
        const options = {method: 'GET'};
        this.counter += 1;
        return new Promise((resolve, reject) => {
            fetch(url, {
                headers,
                ...options,
            })
                .then(response => {
                    response.headers.forEach(function (val, key) {
                        console.log(key + ' -> ' + val);
                    });
                    if (response.ok) {
                        return resolve(response);
                    }
                    return reject(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
    download(fileName, objParams, token, handleError, handleSuccess) {
		const headers = {
			'Cache-Control': 'no-cache, no-store, must-revalidate',
			Pragma: 'no-cahce',
		};
		headers['Authorization'] = token;
		this.fetchGet(`${this.domain}/${this.path}/print${this.objToQueryString(objParams)}`, headers)
			.then(response => {
				return response.blob();
			})
			.then(blob => {
				saveAs(blob, fileName);
				if(handleSuccess){
					handleSuccess();
				}
				return Promise.resolve(blob);
			})
			.catch(err => {
				console.log('downloadFile error', err);
				if (handleError) {
					handleError('Nie można pobrać pliku.')
				}
			});
	}
}
